export default __webpack_public_path__ + "static/media/circleF2P.58d2c3a9.png";